/* AORAKI storefront fixes — progressive enhancement only */
(function () {
  'use strict';

  /* ---------- 1. collection filters: open all groups on desktop ---------- */
  function openFacetPanels() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('.facets__panel').forEach(function (el) {
      if (el.tagName === 'DETAILS' && !el.open) el.open = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFacetPanels);
  } else {
    openFacetPanels();
  }
  window.addEventListener('load', openFacetPanels);

  /* ---------- 2. collection: replace page numbers with "Load more" ---------- */
  function initLoadMore() {
    var grid = document.querySelector('.product-grid');
    var container = document.getElementById('ProductGridContainer');
    if (!grid || !container) return;
    if (container.dataset.loadMoreReady === 'true') return;

    var nav = container.querySelector('.pagination');
    var pageParam = new URL(window.location.href).searchParams.get('page');
    var page = pageParam ? parseInt(pageParam, 10) || 1 : 1;

    // how many products are on screen right now (for the counter)
    var shown = grid.querySelectorAll('.product-grid__item').length;

    var wrap = document.createElement('div');
    wrap.className = 'aoraki-loadmore';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aoraki-loadmore__btn';
    btn.textContent = 'Load more';

    var meta = document.createElement('p');
    meta.className = 'aoraki-loadmore__meta';
    meta.textContent = 'Showing ' + shown + ' products';

    wrap.appendChild(btn);
    wrap.appendChild(meta);
    container.appendChild(wrap);

    container.dataset.loadMoreReady = 'true';
    document.documentElement.classList.add('has-load-more');

    var loading = false;
    var hasNext = !!nav;

    function finish() {
      loading = false;
      btn.disabled = false;
      btn.textContent = 'Load more';
      if (!hasNext) {
        btn.remove();
        meta.textContent = 'You have seen all ' + grid.querySelectorAll('.product-grid__item').length + ' products';
      }
    }

    btn.addEventListener('click', function () {
      if (loading || !hasNext) return;
      loading = true;
      btn.disabled = true;
      btn.textContent = 'Loading…';

      var url = new URL(window.location.href);
      url.searchParams.set('page', String(page + 1));

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('.product-grid__item');
          if (!items.length) { hasNext = false; return; }
          items.forEach(function (el) {
            var node = document.importNode(el, true);
            // the theme's reveal animation only observes nodes present at load,
            // so newly appended cards would stay at opacity 0 — strip it here
            [node].concat([].slice.call(node.querySelectorAll('*'))).forEach(function (n) {
              if (n.classList.contains('scroll-trigger') || n.classList.contains('animate--slide-in')) {
                n.classList.remove('scroll-trigger', 'animate--slide-in');
                n.style.opacity = '1';
                n.style.transform = 'none';
              }
            });
            grid.appendChild(node);
          });
          page += 1;
          hasNext = !!doc.querySelector('.pagination__item--next');
          meta.textContent = 'Showing ' + grid.querySelectorAll('.product-grid__item').length + ' products';
        })
        .catch(function (e) { console.error('load more failed', e); })
        .finally(finish);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }
})();
